import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";

import myGlobals from "../../Utils/globals";
import AlertDialog from "../Common/AlertDialog";
import TopBuildFooter from "../Common/Footer";
import TopBuildHeader from "../Common/Header";
import MyNotificationSystem from "../MyNotificationSystem";
import TopBuildPaymentOnAccountForm from "./PaymentOnAccountForm";

class TopBuildPaymentOnAccount extends React.Component {
  constructor(props) {
    super(props);
    myGlobals.injectProp = this.props.intl;
    this.callDone = false;
  }
  doDummyApiCall = (onSuccess, invdata) => {
    if (!this.callDone) {
      fetch("https://api.myjson.com/bins/19u5ta", {
        method: "GET",
        //body: JSON.stringify(obj),
      })
        .then(function (response) {
          if (response.status !== 200) {
            console.log(
              "Looks like there was a problem. Status Code: " + response.status
            );
            return;
          }
          //console.log(response.text());
          return response.json();
        })
        .then(function (data) {
          onSuccess(data, invdata);
        })
        .catch(function (err) {
          console.log("Fetch Error :-S", err);
          //onFailure(err);
        });
    }
  };
  render() {
    return (
      <Container fluid className="top-build-form-container">
        <MyNotificationSystem />
        <AlertDialog />
        <TopBuildHeader parent="static-poa-header"  />
        <Row
          className="topbuild-form-container static-poa-background"
        >
          <TopBuildPaymentOnAccountForm history={this.props.history} />
        </Row>
        <TopBuildFooter parent="static-poa-footer" />
      </Container>
    );
  }
}

export default TopBuildPaymentOnAccount;
